"use client";
import React, { createContext, useMemo, useState } from "react";

export const LeftNavToggleContext = createContext({
  isLeftNavOpen: false,
  setIsLeftNavOpen: () => "",
});

const LeftNavToggleProvider = ({ children }) => {
  const [isLeftNavOpen, setIsLeftNavOpen] = useState(false);
  const [activeKey, setActiveKey] = useState(null);

  const value = useMemo(
    () => ({
      isLeftNavOpen,
      setIsLeftNavOpen,
      activeKey,
      setActiveKey,
    }),
    [isLeftNavOpen, setIsLeftNavOpen, activeKey, setActiveKey],
  );

  return <LeftNavToggleContext.Provider value={value}>{children}</LeftNavToggleContext.Provider>;
};

export default LeftNavToggleProvider;
